var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d;
import { Component, Prop, Vue, Watch, Ref } from "vue-facing-decorator";
import { GetSystemTrendChartQuery, GetSystemTrendChartQueryModel, MeasurementCategoryModel, SystemComponentQueryModel, SystemComponentTreeModel, MeasurementTypeEnum, ComponentTypeEnum } from "@/app/api/battery-portal-api";
import { ArrayHelper } from "@/app/utils/array-helper";
import { CacheHelper } from "@/app/utils/cache-helper";
import { MeasurementHelper } from "@/app/utils/measurement-helper";
import RouteNames from "@/app/router/routes";
import ComponentTreeVue from "@/app/vues/shared/component-tree.vue";
import pako from 'pako';
let DischargeGraphAxisVue = class DischargeGraphAxisVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.componentTreeKey = 0;
        this.oldComponentTypeId = 0;
        this.locationsPanelVisible = false;
        this.locationsPanelLeft = 0;
        this.locationsPanelTop = 0;
        this.locationsModalVisible = false;
        this.selectAllByDefault = false;
        this.isUpdatingLocations = false;
        this.previousLocationsText = "";
        // query parameters
        this.queryNodes = null;
        this.queryMeasurementTypeId = 0;
        // models
        this.measurementCategory = new MeasurementCategoryModel();
        // save Settings
        this.measureTypePerCategory = new Array();
    }
    created() {
        this.restoreCachedFilter();
        this.measurementCategory.measurementTypes = [];
    }
    ;
    mounted() {
        if (!this.measurementCategories.length)
            return;
        this.setParametersBasedOnQueryString();
        this.setDefaults();
    }
    ;
    setParametersBasedOnQueryString(route) {
        var _a;
        const encodedData = this.$route.query.queryData;
        if (!encodedData)
            return;
        try {
            // Convert base64url to binary data
            const base64 = encodedData.replace(/-/g, '+').replace(/_/g, '/');
            const binaryString = atob(base64);
            const compressed = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                compressed[i] = binaryString.charCodeAt(i);
            }
            // Decompress data
            const decompressed = pako.inflate(compressed);
            const jsonString = new TextDecoder().decode(decompressed);
            const data = JSON.parse(jsonString);
            let axesQuery = GetSystemTrendChartQuery.fromJS(data.trendQuery);
            if (((_a = axesQuery.axes) === null || _a === void 0 ? void 0 : _a.length) < this.index + 1)
                return;
            var query = axesQuery.axes[this.index];
            this.queryMeasurementTypeId = query.measurementTypeId;
            this.queryNodes = query.nodes;
        }
        catch (e) {
            console.error("Error reading trendQuery", e);
        }
    }
    ;
    refreshComponentTree() {
        this.componentTreeKey += 1;
    }
    ;
    resetFilters() {
        this.query.nodes = [];
        this.refreshComponentTree();
    }
    ;
    setMeasurementCategory(option) {
        this.saveMeasurementTypePerCategory();
        this.measurementCategory = option;
        this.restoreMeasurementTypePerCategory();
    }
    ;
    setMeasurementType(item) {
        this.query.measurementTypeId = item.measurementTypeId;
        this.query.measurementTypeName = item.measurementTypeName;
    }
    ;
    saveMeasurementTypePerCategory() {
        if (!this.measurementCategory.measurementCategoryId) {
            return;
        }
        var category = this.measureTypePerCategory.find(x => x.categoryId == this.measurementCategory.measurementCategoryId);
        if (category) {
            category.measurementTypeId = this.query.measurementTypeId;
            category.measurementTypeName = this.query.measurementTypeName;
            this.query.measurementTypeId = 0;
        }
        else {
            category = {
                categoryId: this.measurementCategory.measurementCategoryId,
                measurementTypeId: this.query.measurementTypeId,
                measurementTypeName: this.query.measurementTypeName
            };
            this.measureTypePerCategory.push(category);
        }
    }
    restoreMeasurementTypePerCategory() {
        var category = this.measureTypePerCategory.find(x => x.categoryId == this.measurementCategory.measurementCategoryId);
        if (!category)
            return;
        this.query.measurementTypeId = (category === null || category === void 0 ? void 0 : category.measurementTypeId) || 0;
        this.query.measurementTypeName = (category === null || category === void 0 ? void 0 : category.measurementTypeName) || "";
    }
    // computed
    get visibleComponentTree() {
        let measurementType = this.measurementType;
        if (!measurementType)
            return null;
        if (this.oldComponentTypeId != measurementType.componentTypeId) {
            this.resetFilters();
        }
        this.oldComponentTypeId = measurementType.componentTypeId || 0;
        let result = new Array();
        var componentTypeId = measurementType.componentTypeId;
        if (measurementType.measurementTypeId == MeasurementTypeEnum.AmbientTemperature) {
            componentTypeId = ComponentTypeEnum.Sensor;
        }
        let searchTree = (root, nodes) => {
            if (nodes == null || root == null)
                return;
            let items = new Array();
            for (let i = 0; i < nodes.length; i++) {
                if (nodes[i].componentTypeId != ComponentTypeEnum.String || this.stringIds.includes(nodes[i].componentId)) {
                    let item = new SystemComponentQueryModel();
                    item.init(nodes[i]);
                    items.push(item);
                }
            }
            ;
            let hasValidChild = (children) => {
                if (children == null)
                    return false;
                for (let i = 0; i < children.length; i++) {
                    if (children[i].componentTypeId == componentTypeId) {
                        return true;
                    }
                    if (hasValidChild(children[i].children || null)) {
                        return true;
                    }
                }
                return false;
            };
            for (let i = 0; i < items.length; i++) {
                let item = items[i];
                if (item.componentTypeId == componentTypeId || hasValidChild(item.children || null)) {
                    let children = item.children;
                    item.children = [];
                    root.push(item);
                    searchTree(item.children, children || null);
                }
            }
        };
        searchTree(result, this.componentTree.children || null);
        return result;
    }
    ;
    get systemHasComponents() {
        if (!this.visibleComponentTree)
            return false;
        let components = this.visibleComponentTree;
        return (components && components.length) ? true : false;
    }
    ;
    get measurementTypeId() {
        return this.query.measurementTypeId;
    }
    ;
    get measurementTypeName() {
        return this.query.measurementTypeName;
    }
    ;
    get measurementType() {
        let match = this.measurementTypes.filter(item => {
            return item.measurementTypeId == this.measurementTypeId && item.measurementTypeName == this.measurementTypeName;
        })[0];
        return match;
    }
    ;
    set measurementType(item) {
        if (!item || !item.measurementTypeId)
            return;
        this.query.measurementTypeId = item.measurementTypeId;
        this.query.measurementTypeName = item.measurementTypeName;
    }
    ;
    setDefaults() {
        let preselectedMeasurementTypeId = this.queryMeasurementTypeId;
        if (this.queryMeasurementTypeId) {
            let idx = ArrayHelper.findFirstIndex(this.measurementTypes, (match) => {
                return match.measurementTypeId == preselectedMeasurementTypeId;
            });
            let measurementType = idx > 0 ? this.measurementTypes[idx] : this.measurementTypes[0];
            this.query.measurementTypeId = measurementType.measurementTypeId;
            this.query.measurementTypeName = measurementType.measurementTypeName;
            if (measurementType.measurementCategoryId) {
                let measurementCategory = this.measurementCategories.filter(category => category.measurementCategoryId == measurementType.measurementCategoryId)[0];
                if (measurementCategory)
                    this.setMeasurementCategory(measurementCategory);
            }
        }
        else {
        }
    }
    updateMeasurementType() {
        return __awaiter(this, void 0, void 0, function* () {
            this.previousLocationsText = this.selectedLocationsText;
            this.isUpdatingLocations = true;
            this.$emit("measurementTypeChanged", this.index);
            if (this.selectAllByDefault) {
                this.resetFilters();
                yield new Promise(resolve => setTimeout(resolve, 100));
                yield this.selectAllLocations();
                // Wait for the next tick before enabling UI updates
                yield this.$nextTick();
                this.isUpdatingLocations = false;
            }
            else {
                this.isUpdatingLocations = false;
            }
        });
    }
    ;
    get areNodesInvalid() {
        if (!this.searchAttempted)
            return false;
        if ((!this.query.nodes || !this.query.nodes.length) && this.query.systemId)
            return true;
        return false;
    }
    get isMeasurementInvalid() {
        if (!this.searchAttempted)
            return false;
        if (!this.query.measurementTypeId && this.query.systemId)
            return true;
        return false;
    }
    get selectPlaceholderMeasurement() {
        return "Please select a Measurment Type";
    }
    ;
    get locationsModalId() {
        return "modal-discharge-locations-" + this.index.toString();
    }
    resetMeasurementType() {
        let measurementType = this.measurementTypes[0];
        if (measurementType.measurementCategoryId) {
            let measurementCategory = this.measurementCategories.filter(category => category.measurementCategoryId == measurementType.measurementCategoryId)[0];
            if (measurementCategory)
                this.setMeasurementCategory(measurementCategory);
        }
        else
            this.setMeasurementCategory(this.measurementCategories[0]);
        this.query.measurementTypeId = measurementType.measurementTypeId;
        this.query.measurementTypeName = measurementType.measurementTypeName;
    }
    // Called when the system changes: keep the selected tab/measurement unless the new system's battery type does not offer it.
    // The battery type is passed in because the isLithium props have not been updated yet when the parent's system watcher runs.
    resetMeasurementTypeIfUnavailable(isLithium, isLithiumSamsungG3) {
        if (!MeasurementHelper.isMeasurementTypeAvailable(this.measurementType, isLithium, isLithiumSamsungG3))
            this.resetMeasurementType();
    }
    countStringsSelected() {
        var _a;
        var count = 0;
        (_a = this.visibleComponentTree) === null || _a === void 0 ? void 0 : _a.forEach(item => {
            var _a, _b;
            if ((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.includes(item.componentId)) {
                count++;
            }
            else if (item.children) {
                const hasSelectedChild = (children) => {
                    var hasChild = false;
                    children.forEach(childItem => {
                        var _a, _b, _c;
                        if ((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.includes(childItem.componentId)) {
                            hasChild = true;
                            return;
                        }
                        if (((_c = childItem.children) === null || _c === void 0 ? void 0 : _c.length) && hasSelectedChild(childItem.children)) {
                            hasChild = true;
                            return;
                        }
                    });
                    return hasChild;
                };
                if (hasSelectedChild(item.children))
                    count++;
            }
        });
        return count;
    }
    countBlocksSelected(root) {
        var count = root.filter(x => this.query.nodes.includes(x.componentId) && x.componentTypeId == ComponentTypeEnum.Block).length;
        root.forEach(item => {
            if (item.children) {
                count += this.countBlocksSelected(item.children);
            }
        });
        return count;
    }
    countModuleTempSensorSelected(root) {
        var moduleTempSensorTypeIds = [ComponentTypeEnum.CellTemp, ComponentTypeEnum.TerminalTemp];
        var count = root.filter(x => { var _a, _b; return ((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.includes(x.componentId)) && moduleTempSensorTypeIds.includes(x.componentTypeId); }).length;
        root.forEach(item => {
            if (item.children) {
                count += this.countModuleTempSensorSelected(item.children);
            }
        });
        return count;
    }
    countAmbTempSelected(root) {
        var count = root.filter(x => this.query.nodes.includes(x.componentId) && x.componentTypeId == ComponentTypeEnum.Sensor).length;
        root.forEach(item => {
            if (item.children) {
                count += this.countAmbTempSelected(item.children);
            }
        });
        return count;
    }
    get selectedLocationsPlaceholder() {
        var _a, _b;
        if (!this.visibleComponentTree || !this.systemHasComponents) {
            return "No Locations Available";
        }
        if (!((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.length)) {
            return "Please select Locations";
        }
        return "";
    }
    get selectedLocationsText() {
        var _a, _b;
        if (this.isUpdatingLocations) {
            return this.previousLocationsText;
        }
        if (!this.visibleComponentTree || !this.systemHasComponents || !((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.length)) {
            return "";
        }
        var stringCount = this.countStringsSelected();
        var blockCount = this.countBlocksSelected(this.visibleComponentTree);
        var ambTempCount = this.countAmbTempSelected(this.visibleComponentTree);
        var moduleTempSensorCount = this.countModuleTempSensorSelected(this.visibleComponentTree);
        var textToDisplay = `Selected ${stringCount} String${stringCount > 1 ? 's' : ''}`;
        if (blockCount > 0) {
            textToDisplay += ` and ${blockCount} Block${blockCount > 1 ? 's' : ''}`;
        }
        else if (ambTempCount > 0) {
            textToDisplay += ` and ${ambTempCount} Amb. Temp. Sensor${blockCount > 1 ? 's' : ''}`;
        }
        else if (moduleTempSensorCount > 0) {
            textToDisplay += ` and ${moduleTempSensorCount} Temp. Sensor${moduleTempSensorCount > 1 ? 's' : ''}`;
        }
        return textToDisplay;
    }
    ;
    get selectedLocationsTitle() {
        var _a, _b, _c;
        if (!this.visibleComponentTree || !this.systemHasComponents || !((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.length)) {
            return "";
        }
        var title = "";
        var firstString = true;
        (_c = this.visibleComponentTree) === null || _c === void 0 ? void 0 : _c.forEach(item => {
            if (item.children) {
                var blocks = item.children.filter(x => this.query.nodes.includes(x.componentId));
                if (blocks.length > 0) {
                    if (!firstString) {
                        title += "; ";
                    }
                    title += `${item.componentName} Block${blocks.length > 1 ? 's' : ''}: `;
                    var firstBlock = true;
                    blocks.forEach(block => {
                        if (!firstBlock) {
                            title += ", ";
                        }
                        title += block.componentCode;
                        firstBlock = false;
                    });
                    firstString = false;
                }
            }
        });
        return title;
    }
    ;
    selectAllLocations() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.visibleComponentTree || !this.systemHasComponents)
                return;
            // After a system change the tree still belongs to the previous system until a new event is selected;
            // selecting its nodes would leave locations that do not exist in the new system ("Selected 0 String").
            if (((_a = this.componentTree) === null || _a === void 0 ? void 0 : _a.systemId) && this.query.systemId && this.componentTree.systemId != this.query.systemId)
                return;
            const allSelectableNodes = [];
            // Helper function to recursively collect all selectable node IDs
            const collectSelectableNodes = (nodes) => {
                nodes.forEach(node => {
                    allSelectableNodes.push(node.componentId);
                    if (node.children) {
                        collectSelectableNodes(node.children);
                    }
                });
            };
            // Collect all selectable nodes
            collectSelectableNodes(this.visibleComponentTree);
            this.query.nodes = allSelectableNodes;
        });
    }
    ;
    unselectAllLocations() {
        this.resetFilters();
    }
    ;
    get measurementTypeRequiresNode() {
        if (!this.measurementCategory)
            return true;
        let measurementCategorySystem = 4;
        return this.measurementCategory.measurementCategoryId != measurementCategorySystem;
    }
    get visibleMeasurementCategories() {
        if (this.isLithium) {
            if (this.isLithiumSamsungG3)
                return this.measurementCategories;
            return this.measurementCategories.filter(item => item.measurementCategoryId < 5);
        }
        else {
            return this.measurementCategories.filter(item => item.measurementCategoryId < 4);
        }
    }
    get measurementTypeVisible() {
        var _a, _b;
        console.log(this.isLithiumSamsungG3);
        if (this.isLithium)
            return (_a = this.measurementCategory.measurementTypes) === null || _a === void 0 ? void 0 : _a.filter(item => this.isLithiumSamsungG3 ? item.visibleForLithiumSamsungGen3 : item.visibleForLithium);
        else {
            return (_b = this.measurementCategory.measurementTypes) === null || _b === void 0 ? void 0 : _b.filter(item => item.visibleForNonLithium);
        }
    }
    storeFilterToCache() {
        CacheHelper.storeItem(RouteNames.Discharge, "selectAllByDefault-" + this.index, this.selectAllByDefault);
    }
    ;
    restoreCachedFilter() {
        var _a;
        this.selectAllByDefault = (_a = CacheHelper.getItem(RouteNames.Discharge, "selectAllByDefault-" + this.index)) !== null && _a !== void 0 ? _a : false;
    }
    componentTreeLoaded() {
        var _a;
        if (((_a = this.queryNodes) === null || _a === void 0 ? void 0 : _a.length) > 0)
            setTimeout(() => { this.selectQueryNodes(); }, 100);
        else if (this.selectAllByDefault)
            setTimeout(() => { this.selectAllLocations(); }, 100);
    }
    selectQueryNodes() {
        var _a;
        if (!((_a = this.queryNodes) === null || _a === void 0 ? void 0 : _a.length) || !this.visibleComponentTree || !this.systemHasComponents) {
            return;
        }
        // Recursively collect all componentIds from visibleComponentTree
        const collectIds = (nodes) => {
            const ids = new Set();
            const traverse = (items) => {
                for (const item of items) {
                    ids.add(item.componentId);
                    if (item.children && item.children.length) {
                        traverse(item.children);
                    }
                }
            };
            traverse(nodes);
            return ids;
        };
        const validIds = collectIds(this.visibleComponentTree);
        // Only add queryNodes that exist in visibleComponentTree (root or any child)
        this.query.nodes = this.queryNodes.filter(id => validIds.has(id));
        this.queryNodes = [];
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Number)
], DischargeGraphAxisVue.prototype, "index", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof GetSystemTrendChartQueryModel !== "undefined" && GetSystemTrendChartQueryModel) === "function" ? _a : Object)
], DischargeGraphAxisVue.prototype, "query", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof SystemComponentTreeModel !== "undefined" && SystemComponentTreeModel) === "function" ? _b : Object)
], DischargeGraphAxisVue.prototype, "componentTree", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Array)
], DischargeGraphAxisVue.prototype, "measurementCategories", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Array)
], DischargeGraphAxisVue.prototype, "measurementTypes", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], DischargeGraphAxisVue.prototype, "searchAttempted", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], DischargeGraphAxisVue.prototype, "isLithium", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], DischargeGraphAxisVue.prototype, "isLithiumSamsungG3", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_c = typeof Array !== "undefined" && Array) === "function" ? _c : Object)
], DischargeGraphAxisVue.prototype, "stringIds", void 0);
__decorate([
    Ref("componentTreeVueList"),
    __metadata("design:type", typeof (_d = typeof Array !== "undefined" && Array) === "function" ? _d : Object)
], DischargeGraphAxisVue.prototype, "componentTreeVueList", void 0);
__decorate([
    Watch("query.measurementTypeId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DischargeGraphAxisVue.prototype, "updateMeasurementType", null);
__decorate([
    Watch("selectAllByDefault"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DischargeGraphAxisVue.prototype, "storeFilterToCache", null);
DischargeGraphAxisVue = __decorate([
    Component({
        name: "DischargeGraphAxisVue",
        components: {
            ComponentTreeVue
        },
        emits: ["plot", "measurementTypeChanged"],
        expose: ['measurementTypeRequiresNode', 'resetFilters', 'componentTreeLoaded', 'resetMeasurementTypeIfUnavailable']
    })
], DischargeGraphAxisVue);
export default DischargeGraphAxisVue;
